import { Gym, TimeSlotEligibility, TimeSlotType } from 'fitbeat.models';
import React, { FunctionComponent } from 'react';
import { StyleSheet, Text, View } from 'react-native';
import Theme from '../../theme';

interface IProps {
  timeSlotEligibility: TimeSlotEligibility;
  timeSlotType: TimeSlotType | null;
  userTimeSlotType: TimeSlotType;
  gym: Gym;
  t(key: string): string;
}

// TODO: time slot time should maybe be set in redux and all this logic can be in there to determine the message
export const TimeSlotEligibilityMessage: FunctionComponent<IProps> = ({
  t, timeSlotEligibility, timeSlotType, userTimeSlotType, gym,
}) => {
  if (timeSlotType && timeSlotType === TimeSlotType.None) {
    return (
      <View>
        <Text style={styles.confirmationMessage}>
          {t('bookingSlotUnavailable')}
        </Text>
      </View>
    );
  }
  if (timeSlotEligibility === TimeSlotEligibility.NotAllowedByPaymentPlan) {
    return (
      <View>
        <Text style={styles.confirmationMessage}>
          {t('cantChangeClassBecauseOfSubscription')}
        </Text>
      </View>
    );
  }
  if (timeSlotEligibility === TimeSlotEligibility.NotAllowedFirstSessionMustBePeak) {
    return (
      <View>
        <Text style={styles.confirmationMessage}>
          {t('firstBookingMustBePeak')}
        </Text>
      </View>
    );
  }
  const hasTimeSlotsSupportedByInstructors = gym.displayInstructorContentForTimeSlots.length > 0;
  if (hasTimeSlotsSupportedByInstructors
    && timeSlotType
    && userTimeSlotType === TimeSlotType.AnyTime
    && !gym.displayInstructorContentForTimeSlots.includes(timeSlotType)) {
    return (
      <View>
        <Text style={styles.confirmationMessage}>
          {t('classNotSupportByInstructor')}
        </Text>
      </View>
    );
  }
  if (hasTimeSlotsSupportedByInstructors
    && timeSlotType
    && userTimeSlotType === TimeSlotType.AnyTime
    && gym.displayInstructorContentForTimeSlots.includes(timeSlotType)) {
    return (
      <View>
        <Text style={styles.confirmationMessage}>
          {t('classSupportByInstructor')}
        </Text>
      </View>
    );
  }

  return null;
};

const styles = StyleSheet.create({
  confirmationMessage: {
    fontSize: 14,
    paddingVertical: 10,
    fontFamily: Theme.CustomBold,
    textAlign: 'center',
    color: Theme.GREY_DARK,
  },
});
